// Module
var code = "<i class=\"fa fa-times fa-3x attribute-preview-close\" ng-click=\"close()\"></i> <img class=\"img-responsive attribute-preview-image\" src=\"{{ file.public_path }}\" ng-click=\"close()\"> ";
// Exports
module.exports = code;